module.exports = __webpack_public_path__ + "img/add-to-favorites.9d7be871.svg";